import React from 'react';
import { Alert } from 'antd';
import { CaseParty } from '../../../../services/case';
import PartyForm from './PartyForm';

interface OtherPartyStepProps {
  data: CaseParty[];
  onChange: (data: CaseParty[]) => void;
}

const OtherPartyStep: React.FC<OtherPartyStepProps> = ({ data, onChange }) => {
  return (
    <div>
      <Alert
        message="对方信息"
        description="请添加对方当事人信息。对方是指案件中与我方对立的一方。此步骤为可选，可以稍后补充。"
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
      />
      <PartyForm
        parties={data}
        onChange={onChange}
        partyType="other_side"
        minParties={0}
      />
    </div>
  );
};

export default OtherPartyStep;
